import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";

export default class Muffed extends Fragment {
    constructor(muffedBy) {
        super();
        this.muffedBy = muffedBy;

        this.requiredData = [
            {
                name: "muffedBy",
                type: FragmentDataType.Player,
                displayName: "Muffed by",
                title: (team) => `Muffed By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    getPlayers() {
        return [this.muffedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = `to ${stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            summaryContext.fieldPosition,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        )}, muffed by ${stringifier.firstInitial(this.muffedBy)}`;

        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            muffedBy: playerReducer(this.muffedBy)
        };
    }
}
